import { useEffect, useMemo, useState } from 'react'
import { DisplayFilesProps, TextContainerProps, ZipFileItem } from '../../types'
import JSZip from 'jszip'
import { Box, Breadcrumbs, Button, Typography } from '@mui/material'
import FileAccordion from '../containers/FileAccordion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import TextContainer from './TextContainer'
import util from '../../helpers/util.helper'
import DownloadFileContainer from './DownloadFileContainer'
import { MB_VAL } from '../../config'

export default function ZipContainer({ file, filename }: Readonly<TextContainerProps>) {
    const [rootItem, setRootItem] = useState<ZipFileItem>()
    const [fileSelected, setFileSelected] = useState<ZipFileItem>()
    const [zipError, setZipError] = useState(false)
    const fileType = useMemo(() => util.getFileExtension(fileSelected?.name).type, [fileSelected])

    useEffect(() => {
        const zip = new JSZip();
        setFileSelected(undefined)
        setZipError(false)
        if (!file || !filename.endsWith('.zip') || file.size > 5 * MB_VAL) {
            setZipError(true)
            return
        }
        zip.loadAsync(file)
            .then(zip => util.readZipFile(zip, filename, setRootItem))
            .catch(e => {
                console.log(e)
                setZipError(true)
            })
    }, [file])

    return (
        <Box sx={{ marginTop: '1rem' }}>
            {rootItem && !fileSelected && <DisplayFiles file={rootItem} action={setFileSelected} root={{ name: filename, data: file }} />}
            {fileSelected?.content && <div className='mobile-doc-file'>
                <Breadcrumbs aria-label="breadcrumb">
                    <Button
                        color="inherit"
                        variant='text'
                        onClick={() => setFileSelected(undefined)}
                        style={{ textTransform: 'none' }}
                        startIcon={<FontAwesomeIcon icon={`arrow-left`} />}
                    >
                        <u> {filename} / {fileSelected.path} </u>
                    </Button>
                    <Typography color="text.primary">{fileSelected.name}</Typography>
                </Breadcrumbs>
                {['text', 'xml'].includes(fileType) ? <TextContainer
                    file={fileSelected.content}
                    filename={fileSelected.name}
                    fileExtension={fileType}
                /> : <DownloadFileContainer file={fileSelected.content} artifact={{ id: 0, name: fileSelected.name, type: fileType }} />}
            </div>}
            {file && zipError && <DownloadFileContainer file={file} artifact={{ id: 0, name: filename, type: 'zip' }} />}
        </Box>
    )
}

function DisplayFiles({ file, action, root }: DisplayFilesProps) {
    if (!file.isDirectory) {
        return <div>
            ---  <Button
                startIcon={<FontAwesomeIcon icon={`file-alt`} className='m-auto' />}
                style={{ padding: '0', textTransform: 'none' }}
                onClick={() => action(file)}
                color='primary'
            >
                {file.name}
            </Button>
        </div>
    }
    return <FileAccordion
        expanded
        header={file.name}
        append={root?.data ? <Button
            onClick={() => util.downloadFile(root.name, root.data)}
            style={{ padding: 0, textTransform: 'none', marginLeft: 'auto' }}
            variant='text'
            color='primary'
            startIcon={<FontAwesomeIcon icon="download" />}
        >
            Descargar
        </Button> : undefined}
    >
        {file.files?.map(f => <DisplayFiles key={f.name} file={f} action={action} />)}
    </FileAccordion>
}